import { render, staticRenderFns } from "./PunchLogSecurityDetail.vue?vue&type=template&id=372d3e36&scoped=true&"
import script from "./PunchLogSecurityDetail.vue?vue&type=script&lang=js&"
export * from "./PunchLogSecurityDetail.vue?vue&type=script&lang=js&"
import style0 from "./PunchLogSecurityDetail.vue?vue&type=style&index=0&id=372d3e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372d3e36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VSelect,VTextField})
